/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CommitPayload,
  CreateDocumentFilePayload,
  DocumentGet,
  DocumentLockGet,
  DocumentViewModel,
  GetDocumentListParams,
  GetLockParams,
  LockBody,
  TableModel1DocumentGet,
  TableModel1DocumentLockGet,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Documents<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Documents
   * @name DocumentsDetail
   * @summary Получить документ по идентификатору
   * @request GET:/documents/{id}
   * @secure
   * @response `200` `DocumentGet` Документ
   */
  documentsDetail = (id: string, params: RequestParams = {}) =>
    this.request<DocumentGet, any>({
      path: `/documents/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name GetDocumentList
   * @summary Возвращает список документов, удовлетворяющие критериям фильтрации.
   * @request GET:/documents/list/{CategoryId}
   * @secure
   * @response `200` `TableModel1DocumentGet` Список документов
   */
  getDocumentList = ({ categoryId, ...query }: GetDocumentListParams, params: RequestParams = {}) =>
    this.request<TableModel1DocumentGet, any>({
      path: `/documents/list/${categoryId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name CreateDocument
   * @summary Создание документа
   * @request POST:/documents/create
   * @secure
   * @response `200` `void` Success
   */
  createDocument = (data: DocumentViewModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/documents/create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name UpdateDocument
   * @summary Обновление документа
   * @request POST:/documents/{id}/update
   * @secure
   * @response `200` `void` Success
   */
  updateDocument = (id: string, data: DocumentViewModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/documents/${id}/update`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name DeleteDocument
   * @summary Удаление документа
   * @request POST:/documents/{id}/delete
   * @secure
   * @response `200` `void` Success
   */
  deleteDocument = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/documents/${id}/delete`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name CreateDocumentFile
   * @summary Добавление Файла
   * @request POST:/documents/createFile
   * @secure
   * @response `200` `string` Путь файла
   */
  createDocumentFile = (data: CreateDocumentFilePayload, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/documents/createFile`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name GetFileByDocumentId
   * @summary Возвращает файл по id документа
   * @request GET:/documents/{id}/getFile
   * @secure
   * @response `200` `File` Файл документа
   */
  getFileByDocumentId = (id: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/documents/${id}/getFile`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name GetFileByHash
   * @summary Возвращает файл по хэшу документа
   * @request GET:/documents/getFileByHash/{Hash}
   * @secure
   * @response `200` `File` Файл документа
   */
  getFileByHash = (hash: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/documents/getFileByHash/${hash}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name Lock
   * @summary Возвращает документ по id с пометкой на редактирование
   * @request POST:/documents/{id}/lock
   * @secure
   * @response `200` `DocumentLockGet` Документ с пометкой на редактирование
   */
  lock = (id: string, data: LockBody, params: RequestParams = {}) =>
    this.request<DocumentLockGet, any>({
      path: `/documents/${id}/lock`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name Commit
   * @summary Сохраняет ранее  взятый документ на редктирование
   * @request POST:/documents/commit
   * @secure
   * @response `200` `void` Success
   */
  commit = (data: CommitPayload, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/documents/commit`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name Unlock
   * @summary Отменяет запрос на редактирование документа
   * @request GET:/documents/unlock/{id}
   * @secure
   * @response `200` `void` Success
   */
  unlock = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/documents/unlock/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name GetLock
   * @summary Получает список документов взятые на редактирование
   * @request GET:/documents/getLock
   * @secure
   * @response `200` `TableModel1DocumentLockGet` Список документов с пометкой на редактирование
   */
  getLock = (query: GetLockParams, params: RequestParams = {}) =>
    this.request<TableModel1DocumentLockGet, any>({
      path: `/documents/getLock`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
}
